import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import Loading from '../../../Global/Components/LoadingSpinner';
import { StateContext } from '../../../Controllers/context/state';
import supabase from '../../../Controllers/utils/supabaseClient';
import ExpandedView from '../../../Global/Components/ExpandedView/ExpandedView';
import MacroSummariesFeed from '../../../Global/Views/FeedViewer/MacroSummariesFeed';
import { Header } from '../../../Global/StyledComponents/UserFormStyledComponents';
import SectorOverview from '../../../Global/Components/StockChartWrapper/components/SectorOverview/SectorOverview';
import { AppColors } from '../../../Global/StyledComponents/Graphics';


const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	margin-top: 10px;
	position: relative;
	overflow: auto;
	scrollbar-width: none;
	-ms-overflow-style: none;
	gap: 20px;
	&::-webkit-scrollbar {
		display: none;
		overflow: hidden;
	}
`;

const Column = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
`;

const SectorLoadingCard = styled.div`
	width: 100%;
	min-height: 300px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 15px;
	background: ${AppColors.MRNAVY20};
	border: 1px solid ${AppColors.MRNAVY40};
	border-radius: 4px;
	padding: 40px 20px;
`;

const LoadingText = styled.div`
	color: ${AppColors.MRLITE80};
	font-size: 14px;
	font-family: Mulish, Arial, Helvetica, sans-serif;
`;

const ChartInfoWindow = ({ setShowChartInfoWindow }) => {
    const [windowData, setWindowData] = useState(null);
    const [etfWindowData, setEtfWindowData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [etfLoading, setEtfLoading] = useState(false);
    const { chartInfo, logError, sort, sectorSymbol } = useContext(StateContext);
    

    // Add ETF data fetching function
    const fetchETFData = async ({ retry = true }) => {
        setEtfLoading(true);
        let data;

        const res = await supabase.rpc('get_expanded_summary_for_chart', {
            _symbol: sectorSymbol,
            _aggr: 'dtm',
            _epoch: chartInfo.time_utc / 1000,
            _corrasset: sort.correlationAsset,
        });

        if (res?.error) {
            const error = new Error(res?.error?.message);
            if (retry && res?.error?.message !== 'FetchError: Failed to fetch') {
                fetchETFData({ retry: false });
                return;
            }
            logError(error);
        }
        if (res?.data?.length) {
            data = res?.data?.[0]?.data_row;
        }

        setEtfWindowData(data);
        setEtfLoading(false);
        return data;
    };



    const fetchData = async ({ retry = true }) => {
        let data;
        
        const res = await supabase.rpc('get_expanded_summary_for_chart', {
            _symbol: chartInfo.symbol,
            _aggr: chartInfo.aggr,
            _epoch: chartInfo.time_utc / 1000,
            _corrasset: sort.correlationAsset,
        });

        if (res?.error) {
            const error = new Error(res?.error?.message);
            if (retry && res?.error?.message !== 'FetchError: Failed to fetch') {
                fetchData({ retry: false });
                return;
            }
            logError(error);
        }

        if (res?.data?.length) {
            data = res?.data?.[0]?.data_row;
        }

        setWindowData(data);
        return data;
    };
    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
                    if (chartInfo?.isCard) {
                setWindowData(chartInfo);
            } else {
                await fetchData({ retry: true });
            }

            const needsEtfData = sectorSymbol && sectorSymbol !== chartInfo.symbol;
            if (needsEtfData) {
                if (chartInfo?.etfData) {
                    setEtfWindowData(chartInfo.etfData);
                } else {
                    await fetchETFData({ retry: true }).catch(err => console.error('ETF fetch error:', err));
                }
            }

            setLoading(false);
        };
        loadData();
    }, [chartInfo, sectorSymbol]);

    if (loading) {
        return (
            <Container>
                <Loading />
            </Container>
        );
    }

    return (
        <Container>
            <Column style={{ flex: 1 }}>
                <ExpandedView showInfo data={windowData} etfData={etfWindowData}/>
            </Column>
  
        </Container>
    );
};

export default ChartInfoWindow;
